<template>
  <div class="boxbgcolor ioRecord presence-record">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label for>车牌号:</label>
            <input
              v-model="search.plateNumber"
              class="form-control"
             
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for>卡类型:</label>
            <el-select v-model="search.plateType" clearable placeholder="请选择">
              <el-option
                v-for="item in allPlateTypes"
                :key="item.value"
                :label="item.labelDefault"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>进场时间:</label>
            <!-- <el-date-picker
              v-model="search.inTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker> -->
            <bosk-shortcut-datetime
           
            
            ></bosk-shortcut-datetime>
            <!-- <bosk-shortcut-datetime v-on:current-datetime-change="onCurrentDatetimeChange"></bosk-shortcut-datetime> -->
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button @click="searchList" type="primary" :loading="loading" id="search_btn" size="small">查询</el-button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
         
            <!-- <span class="refresh_btn"><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <!--左侧列表展示进出场记录-->
      <div class="list-right">
        <el-table
          :data="tableListData.rows"
          border
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          height="100%"
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column  show-overflow-tooltip label="车场名称" prop="parkingId">
            <template
              slot-scope="scope"
            >{{scope.row.parkingId?JSON.parse(scope.row.parkingId).parkingName:''}}</template>
          </el-table-column>
          <el-table-column  show-overflow-tooltip label="车牌号码" prop="plateNumber"></el-table-column>
          <el-table-column  show-overflow-tooltip label="车类型" prop="carType"></el-table-column>
          <el-table-column  show-overflow-tooltip label="车牌颜色" prop="plateColor"></el-table-column>
          <el-table-column  show-overflow-tooltip label="卡类型" prop="plateType"></el-table-column>
          <el-table-column  show-overflow-tooltip label="进场通道" prop="channelInId">
            <template
              slot-scope="scope"
            >{{scope.row.channelInId?JSON.parse(scope.row.channelInId).name:''}}</template>
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip
						label="停车区域"
						prop="">
          </el-table-column>-->
          <el-table-column  show-overflow-tooltip label="进场时间" prop="beginDate"></el-table-column>
          <!-- <el-table-column  show-overflow-tooltip
						label="车主"
						prop="">
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="联系电话"
						prop="">
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="当班人员"
						prop="">
          </el-table-column>-->
        </el-table>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  indoorIoRecordList,
  indoorAllCarType,
  indoorAllPlateType,
  indoorAllOpenMethod
} from "@/api/url";

import Page from "../../commons/page.vue";

import AreaTree from "../../commons/parking/commons/areaTree.vue";

import Refresh from "../../commons/parking/commons/refresh.vue";

export default {
  name:'presence-record',
  data() {
    return {
      loading: false,
      currentDate:'',
      treeData: {
        parkingId: ""
      },
      styleObj: {
        "text-align": "center"
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB"
      },
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        inTime: [],
        plateNumber: "",
        plateType: ""
      },
      tableListData: {
        rows: []
      },
      allCarTypes: null,
      allPlateTypes: null,
      allOpenMethods: null,
      defaultProps: {
        children: "children",
        label: "label"
      },

      formLabelWidth: "100px",

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: "",
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场"
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function(node, data) {
      this.search.plateNumber = "";
      // this.search.inTime = [];
      this.search.plateType = "";
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      } else {
        this.treeData.parkingId = "";
        // this.tableListData = [];
        this.tableListData.rows = []
        // this.$message({
        // 	type:'warning',
        // 	message:'请选择停车场'
        // })
        return;
      }
      // if(node.level==2){
      // 	this.treeData.parkingId=data.parent.data.id;
      // 	this.treeData.areaId=node.id;
      // }
    },
    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      this.$get(indoorIoRecordList(), {
        plateNumber: this.search.plateNumber,
        parkingId: this.treeData.parkingId,
        plateType: this.search.plateType,
        beginTime: this.search.inTime ? this.search.inTime[0] : "",
        endTime: this.search.inTime ? this.search.inTime[1] : "",
        limit: this.search.pageSize,
        page: curPage,
        position: "0"
      }).then(data => {
        if (data.status != 200) return;
        //翻页
        // var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total
        };
        _this.pageObj={...pageObj}
        // _this.getPage(pageObj);
        //  console.log(data.data.rows)
        _this.tableListData.rows = data.data.rows;
      }).finally(() => {
        this.loading = false;
      });
    },
    getAllCarType() {
      this.$get(indoorAllCarType()).then(data => {
        if (data.status != 200) return;
        this.allCarTypes = data.data.rows;
      });
    },
    getAllPlateType() {
      this.$get(indoorAllPlateType()).then(data => {
        if (data.status != 200) return;
        this.allPlateTypes = data.data.rows;
      });
    },
    getAllOpenMethod() {
      this.$get(indoorAllOpenMethod()).then(data => {
        if (data.status != 200) return;
        this.allOpenMethods = data.data.rows;
      });
    },
    searchList: function() {
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场"
        });
        return;
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    // onCurrentDatetimeChange(v){
    //   this.search.inTime=[...v]
    //   console.log('parent date=>',v)
    // },
  },
  computed: {
    ...mapState({
      curIndex: state => state.page.curIndex,
      rowsCount: state => state.page.rowsCount,
      nodeData: state => state.nodeData,
      nod: state => state.nod
    })
  },
  components: {
    Page,
    AreaTree,
    Refresh
  },

  mounted: function() {
    // this.tableList(this.search.pageNumber);
    this.getAllCarType();
    this.getAllPlateType();
    this.getAllOpenMethod();
  }
};
</script>

<style scoped>
.boxbgcolor {
  /*margin-top:20px;*/
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
		line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.demo-table-expand {
  font-size: 0;
}
.detail {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.detail ul {
  width: 50%;
}
.detail ul li {
  padding: 10px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail ul li span {
  display: inline-block;
  width: 50%;
}
.detail ul li span:first-child {
  text-align: right;
  color: #aaa;
  font-weight: bold;
  width: 100px;
}
.detail ul li span:last-child {
  text-align: left;
  padding: 0 0 0 20px;
}
.presence-record .list-right{
  height:calc(100vh - 220px)
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
</style>